import { render, staticRenderFns } from "./SecondWaybillNav.vue?vue&type=template&id=58041f42&scoped=true&"
import script from "./SecondWaybillNav.vue?vue&type=script&lang=js&"
export * from "./SecondWaybillNav.vue?vue&type=script&lang=js&"
import style0 from "./SecondWaybillNav.vue?vue&type=style&index=0&id=58041f42&prod&scoped=true&lang=css&"
import style1 from "./SecondWaybillNav.vue?vue&type=style&index=1&id=58041f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58041f42",
  null
  
)

export default component.exports